import { z } from "zod"
import { Locale } from "../employees/response_data"

export const OrganizationTypeEnum = {
  Freemium: "Freemium",
  Client: "Client",
  Integration: "Integration",
  Partner: "Partner",
} as const

export const CompanyUsageKind = {
  Feedback: "Feedback",
  Support: "Support",
} as const

export const UpdateCompanyBody = z.object({
  name: z.string().optional(),
  email: z.string().optional().nullable(),
  website: z.string().optional().nullable(),
  locale: z.enum(Locale).optional(),
  slug: z.string().optional().nullable(),
  location: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  products: z.string().optional().nullable(),
  values: z.string().optional().nullable(),
  toneOfVoice: z.string().optional().nullable(),
  examples: z.string().optional().nullable(),
  additionalInfo: z.string().optional().nullable(),
  emailSignature: z.string().optional().nullable(),
})

export const UploadSignatureImageFileSchema = z.object({
  file: z.object({
    data: z.unknown().refine((value) => Buffer.isBuffer(value), {
      error: "Expected a Buffer",
    }),
    name: z.string(),
    mimetype: z.string(),
  }),
})

export const UpdateCompanyFiles = z.object({
  logo: z
    .object({
      data: z.unknown().refine((value) => Buffer.isBuffer(value), {
        error: "Expected a Buffer",
      }),
      name: z.string(),
      mimetype: z.string(),
    })
    .optional()
    .nullable(),
})
